const SMALL_WORDS = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'via', 'with']);
const ACRONYMS = new Set(['ai', 'cs', 'ds', 'ui', 'ux', 'us', 'nj', 'nyc', 'stem', 'gis', 'dna', 'rna', 'sas', 'ece']);
const ROMAN = /^[ivx]{1,4}$/;

/**
 * The Rutgers catalog ships titles in capitals ("INTRO TO REAL ANALYSIS I").
 * Readable title case keeps Roman numerals and common acronyms upright and
 * lowercases short joining words after the first. Titles that already mix
 * cases are returned unchanged.
 */
export function readableCourseTitle(title: string) {
  if (!title || title !== title.toUpperCase()) return title;
  let wordIndex = 0;
  return title
    .toLowerCase()
    .split(/(\s+|-|\/|&|\(|\))/)
    .map((part) => {
      if (!/[a-z]/.test(part)) return part;
      const first = wordIndex++ === 0;
      if (ROMAN.test(part) || ACRONYMS.has(part)) return part.toUpperCase();
      if (!first && SMALL_WORDS.has(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join('');
}
